import { service, BASE_API } from '@/utils/request'
const v2 = BASE_API

export default {
    // 下载模板
    downloadUrl: 'https://file.ibabygroup.cn/manage/hospitalpay.xlsx',
    // 导入用户
    importExcel: v2 + '/cloud/order/hospitalGroupBuy/importExcel',
    // 获取列表数据
    getDataList(params) {
        return service({
			url: '/cloud/order/hospitalGroupBuy/pages',
			method: 'get',
			params
		})
    },
    // 开启收款
    openPay(params) {
        return service({
			url: '/cloud/order/hospitalGroupBuy/open',
			method: 'post',
			params
		})
    },
    // 删除收款
    removePay(params) {
        return service({
			url: '/cloud/order/hospitalGroupBuy/delete',
			method: 'post',
			params
		})
    },
    // 新增/编辑收款
    savePay(data) {
        return service({
          url: '/cloud/order/hospitalGroupBuy/save',
          method: 'post',
          data
        })
    },
    // 手动开通
    manualOpen(params) {
        return service({
          url: '/cloud/order/hospitalGroupBuy/manualOpen',
          method: 'post',
          params
        })
    },
	// 导出Excel
    exportExcel(params) {
        return service({
            url: '/cloud/order/hospitalGroupBuy/exportExcel',
            method: 'get',
            params,
            responseType: 'blob'
        })
    },
    // 收款单详情
    detail(params) {
        return service({
			url: '/cloud/order/hospitalGroupBuy/detail',
			method: 'get',
			params
		})
    },
    // 单个短信提醒
    sendRemind(params) {
        return service({
			url: '/cloud/order/hospitalGroupBuy/sendRemind',
			method: 'post',
			params
		})
    },
    // 批量短信提醒
    batchSendRemind(params) {
        return service({
			url: '/cloud/order/hospitalGroupBuy/batchSendRemind',
			method: 'post',
			params
		})
    },
    // 分页查询收款用户列表
    userPages(params) {
        return service({
			url: '/cloud/order/hospitalGroupBuy/userPages',
			method: 'get',
			params
		})
    },
    // 将收款单用户移除名单
    removeUser(params) {
        return service({
			url: '/cloud/order/hospitalGroupBuy/removeUser',
			method: 'post',
			params
		})
    }
}



// WEBPACK FOOTER //
// ./src/api/thirdManage/hospital_vip_pay.js